import React from "react";
import MUIIconButton, {
  IconButtonProps as MUIIconButtonProps
} from "@mui/material/IconButton";

export function IconButton({
  children,
  ...iconButtonProps
}: MUIIconButtonProps) {
  return <MUIIconButton {...iconButtonProps}>{children}</MUIIconButton>;
}
